import I18n from 'i18n-js';
import { object, string } from 'prop-types';

import Image, { ImageLoader } from '~/components/Image';

import bundleImagePlaceholder from '~/assets/images/lootboxes/bundleImage.png';
import detailBannerPlaceholder from '~/assets/images/lootboxes/detailBanner.png';

import style from './LootHeader.module.scss';

const defaultColor = '#000';

const LootHeader = ({
  detailBanner,
  name,
  bundleImage,
  lootTypeTag,
  separatorTag,
  countryIcon,
  headline,
  subHeadline,
}) => {
  const separatorColor = separatorTag?.labelColor || defaultColor;
  const lootTypeColor = lootTypeTag?.labelColor || defaultColor;
  const lootTypeLabel = lootTypeTag?.titleLong;
  const platformIcon = separatorTag?.filterIcon;

  return (
    <div className={style.header}>
      <div
        className={style.detailBanner}
        style={{
          borderBottom: `5px ${separatorColor} solid`,
        }}
      >
        <ImageLoader
          alt="Detail banner"
          path={detailBanner}
          src={detailBannerPlaceholder}
          title={name}
          width={400}
          height={500}
          className={style.detailBannerImage}
        />
      </div>
      <ImageLoader
        alt="Bundle image"
        path={bundleImage}
        width={139}
        height={280}
        className={style.bundleImage}
        src={bundleImagePlaceholder}
      />
      <div className={style.iconsSection}>
        {countryIcon ? (
          <div className={style.countryIcon}>
            <span>{I18n.t('UserDetailsView_country')}</span>
            <Image
              alt="Country icon"
              path={countryIcon}
              height={25}
              width={25}
            />
          </div>
        ) : (
          <div />
        )}
        {platformIcon ? (
          <div className={style.platformIcon}>
            <span>{I18n.t('CardListView_filter_description_platform')}</span>
            <Image
              alt="Platform icon"
              path={platformIcon}
              height={25}
              width={25}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
      <div>
        <div className={style.tagHolder}>
          {lootTypeLabel && (
            <span style={{ backgroundColor: lootTypeColor }}>
              {lootTypeLabel.toUpperCase()}
            </span>
          )}
        </div>
        <h1>{!headline && !subHeadline ? name : headline}</h1>
        {subHeadline && <h2>{subHeadline}</h2>}
      </div>
    </div>
  );
};

LootHeader.propTypes = {
  detailBanner: string,
  name: string,
  bundleImage: string,
  countryIcon: string,
  headline: string,
  subHeadline: string,
  lootTypeTag: object,
  separatorTag: object,
};

export default LootHeader;
